import { css } from "@emotion/react";
import { designTokens, RiKey2Line } from "@itandi/itandi-bb-ui";
import { useDealVendorNoteContext } from "~/components/common/deals/show/vendor_card/DealVendorNoteProvider";
import { Button } from "~/components/common/parts/button/Button";
import Styles from "./DealVendorNoteNavigation.module.scss";

const navigationCssVariables = {
	"--background-color-optional-label":
		designTokens["color/background/default/subtler"],
	"--border-radius": `${designTokens["border-radius/s"]}px`,
	"--border-width": `${designTokens["border-width/l"]}px`,
	"--font-size-optional-label": `${designTokens["text/label/xs"]}px`,
	"--font-size-title": `${designTokens["text/label/m"]}px`,
	"--spacing-block": `${designTokens["spacing/m"]}px`,
	"--spacing-component": `${designTokens["spacing/s"]}px`,
	"--spacing-internal": `${designTokens["spacing/xxs"]}px`,
	"--spacing-layout": `${designTokens["spacing/l"]}px`,
	"--spacing-minimum": `${designTokens["spacing/xxxs"]}px`,
	"--spacing-navigation": `${designTokens["spacing/xl"]}px`,
	"--text-color-optional-label": designTokens["color/text/subtle"]
} as const satisfies Record<string, string>;

export function DealVendorNoteNavigation() {
	const { dealVendorNote, handleOpen, isReady } = useDealVendorNoteContext();
	const hasNote = dealVendorNote !== null && dealVendorNote.note.trim() !== "";

	return isReady ? (
		<div className={Styles.NavigationBlock} css={css(navigationCssVariables)}>
			<div className={Styles.IconWrapper}>
				<RiKey2Line className={Styles.Icon} />
			</div>
			<div className={Styles.NavigationContent}>
				<div className={Styles.Content}>
					<h4 className={Styles.Title}>
						「共有案件メモ」に鍵・キーボックス情報を入力してください
						<span className={Styles.OptionalLabel}>任意</span>
					</h4>
					<span className={hasNote ? undefined : Styles.NotYet}>
						{hasNote ? "入力済み" : "未入力"}
					</span>
				</div>
				<div className={Styles.DetailLinkBlock}>
					<Button
						className={Styles.DetailLinkButton}
						onClick={handleOpen}
						size="lg"
						variant="normal"
					>
						鍵情報を入力
					</Button>
				</div>
			</div>
		</div>
	) : null;
}
